import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AsyncReducerStatus } from 'store/common/AsyncReducerStatus';
import { useTypedSelector } from 'store/common/TypedSelector';

import { SequenceViewModel } from 'services/device/domain/model/SequenceModel';
import { SequenceModelState } from 'services/device/domain/model/SequenceModelState';
import { SequenceArchiveForm } from 'services/device/presentation/ui/sequence-action/sequence-archive-form/SequenceArchiveForm';
import { SequenceArchiveFailedNotification } from 'services/device/presentation/ui/sequence-action/sequence-archive-modal/SequenceArchiveFailedNotification';
import { updateSequence } from 'services/device/store/sequenceSlice';

import { ModalDialogue } from 'presentation/ui/compositions/modal-dialogue/ModalDialogue';
import { ModalDialogueHeight } from 'presentation/ui/compositions/modal-dialogue/ModalDialogueHeight';

export interface SequenceArchiveModalProps {
	sequence: SequenceViewModel
	onDismiss?: () => void;
}

export const SequenceArchiveModal = (props: SequenceArchiveModalProps): JSX.Element => {
	const { sequence, onDismiss } = props;

	const deviceActionStatus = useTypedSelector(state => state.sequences.actionStatus);

	const dispatch = useDispatch();

	useEffect(() => {
		if (deviceActionStatus === AsyncReducerStatus.UPDATED) {
			onDismiss();
		}
	}, [deviceActionStatus, onDismiss]);

	const handleUpdate = (): void => {
		sequence.State = SequenceModelState.ARCHIVED;
		dispatch(updateSequence(sequence));
	};

	const renderModalContent = () => {
		let modalContent: JSX.Element = null;

		switch (deviceActionStatus) {
			case AsyncReducerStatus.IDLE:
				modalContent =
					<SequenceArchiveForm
						sequence={sequence}
						onUpdate={handleUpdate}
						onDismiss={onDismiss}
					/>;
				break;

			case AsyncReducerStatus.FAILED:
				modalContent = <SequenceArchiveFailedNotification
					onDismiss={onDismiss}
				/>;
				break;
		}

		return modalContent;
	};

	return (
		<ModalDialogue height={ModalDialogueHeight.HEIGHT_FLEX}>
			{renderModalContent()}
		</ModalDialogue>
	);
};
